import {
  CLEAR_TRANSFERRING_REQUEST_CREATED_UPDATED,
  GET_TRANSFERRING_REQUESTS,
  SET_TRANSFERRING_REQUEST_DETAILS,
  SEND_EXPORT_EXCEL_REQUEST,
} from '../../modules/constants';

export function getTransferringRequestsList(value) {
  return {
    type: GET_TRANSFERRING_REQUESTS,
    payload: value,
  };
}

export function sendExportExcelRequest(params, type) {
  return {
    type: SEND_EXPORT_EXCEL_REQUEST,
    payload: { params, type },
  };
}